export default __webpack_public_path__ + "static/sh-3a416f068bf911b8571b7a9c6ff6560c.svg";